export const userPermissions = {
  admin_dashboard: false,
  settings_modify: false,
  users_modify: false,
  users_add: false,
  payment_approval: false,
  users_view: false,
  master_accounts_list: false,
  master_accounts_upsert: false,
  carriers_add: false,
  carriers_quick_add: false,
  carriers_view: false,
  carriers_modify: false,
  carriers_export_data: false,
  carriers_cancel: false,
  carriers_image_upload: false,
  carriers_image_remove: false,
  carriers_document_upload: false,
  carriers_document_remove: false,
  auction_view: false,
  auction_doc_upload: false,
  auction_export_data: false,
  auction_document_remove: false,
  carriers_customer_sensitive_data: false,
  carriers_share: false,
  carriers_book: false,
  carriers_image_zip: false,
  customers_view: false,
  customers_modify: false,
  customer_export_data: false,
  export_transactions: false,
  carrier_delivery_approval: false,
  carrier_shipping_approval: false,
  carrier_payment_approval: false,
  profit_loss_report_view: false,
  profit_loss_report_export: false,
  profit_loss_report_share: false,
  master_user_role_view: false,
  master_user_role_add: false,
  master_user_role_modify: false,
  carrier_delivered: false,
  transport_add: false,
  shipping_export: false,
  shipping_instructions: false,
  shipping_invoice: false,
  shipping_doc_upload: false,
  shipping_cancel: false,
  proforma_invoice: false,
  commercial_invoice: false,
  invoice_view: false,
  invoice_export: false,
  invoice_share: false,
  payment_add: false,
  payment_view: false,
  payment_export: false,
  master_voyage_view: false,
  master_voyage_upsert: false,
  master_make_model_view: false,
  master_make_model_upsert: false,
  master_auction_house_view: false,
  master_auction_house_upsert: false,
  master_shipping_company_view: false,
  master_shipping_company_upsert: false,
  master_shipping_agent_view: false,
  master_shipping_agent_upsert: false,
  master_transport_company_view: false,
  master_transport_company_upsert: false,
  master_inspection_company_view: false,
  master_inspection_company_upsert: false,
  master_location_view: false,
  master_location_upsert: false,
  master_forwarder_view: false,
  master_forwarder_upsert: false,
  master_forwarder_charge_view: false,
  master_forwarder_charge_upsert: false,
  master_dealer_view: false,
  master_dealer_upsert: false,
  master_seller_view: false,
  master_seller_upsert: false,
  master_location_forwarder_view: false,
  master_location_forwarder_upsert: false,
  master_freight_charge_view: false,
  master_freight_charge_upsert: false,
  transport_view: false,
  transport_modify: false,
  transport_export: false,
  inspection_view: false,
  inspection_add: false,
  inspection_modify: false,
  inspection_export: false,
  shipping_view: false,
  shipping_book: false,
  shipping_modify: false,
  master_transport_charge_list: false,
  master_transport_charge_upsert: false,
  master_inspection_charge_list: false,
  master_inspection_charge_upsert: false,
  credit_note_view: false,
  credit_note_add: false,
  credit_note_export: false,
  debit_note_generate: false,
  advance_amount_record: false,
  tax_balance_report_view: false,
  tax_balance_report_export: false,
  tax_balance_report_share: false,
  export_ranking_report_view: false,
  export_ranking_report_export: false,
  export_ranking_report_share: false,
  stock_inventory_report_view: false,
  stock_inventory_report_export: false,
  stock_inventory_report_share: false,
  custom_report_view: false,
  custom_report_export: false,
  custom_report_share: false,
  transaction_single_view: false,
  payment_single_view: false,
  invoice_single_view: false,
  carrier_single_view: false,
  credit_note_single_view: false,
  customer_transactions: false,
  customer_payments: false,
  customer_invoices: false,
  customer_carriers: false,
  customer_dashboard: false,
  customer_sensitive_data: false,
  staff_dashboard: false,
  settings_view: false,
  users_customer_add: false,
  tasks_assign: false,
  tasks_view: false,
  notifications_view: false,
  alarms_view: false,
  profile_update: false,
  multi_expense_menu: false,
  transport_invoice_bulk_update: false,
  inspection_fee_bulk_update: false,
  recycle_fee_refund_upload: false,
  recycle_fee_refund_update: false,
  freight_charge_bulk_update: false,
  multi_document_upload: false,
};

export const awsApiErrorCodes = {
  UsernameExistsException:
    'An account with this email or username already exists.',
  InvalidPasswordException: 'Password does not meet the required complexity.',
  InvalidParameterException: 'One or more provided parameters are invalid.',
  CodeDeliveryFailureException:
    'Unable to send verification code. Please try again.',
  LimitExceededException: 'Attempt limit exceeded. Please try again later.',
  TooManyRequestsException:
    'Too many requests. Please wait and try again later.',
  UserLambdaValidationException:
    'Sign-up failed due to a validation error. Please check your input.',
  NotAuthorizedException: 'You are not authorized to perform this action.',
  UnexpectedLambdaException:
    'An unexpected error occurred. Please try again later.',
  InvalidLambdaResponseException:
    'Invalid response from the server. Please try again.',
  AliasExistsException: 'This alias (email/phone number) is already in use.',
  ResourceNotFoundException:
    'Requested resource not found. Please contact support.',
  InternalErrorException: 'An internal error occurred. Please try again later.',
};
